import { BASE_GROUND_OFFSET } from "../config";
import { BLOCK, type VoxelWorld } from "../types";

/**
 * For every non-river surface cell, if any 4-neighbor has water or ice
 * directly above its top, replace this cell's surface with sand. Auto-beaches.
 *
 * Skips cells whose surface is already sand or sandstone, and cells that have
 * a snow_block / fluid / structure already sitting on top.
 */
export function applyCoastRule(
    world: VoxelWorld,
    heights: number[][],
): void {
    const N = heights.length;

    const fluidAt = (x: number, z: number): boolean => {
        if (x < 0 || z < 0 || x >= N || z >= N) return false;
        const top = BASE_GROUND_OFFSET + heights[x][z];
        const above = world.get(x, top + 1, z);
        return above === BLOCK.Water || above === BLOCK.Ice;
    };

    for (let x = 0; x < N; x++) {
        for (let z = 0; z < N; z++) {
            const top = BASE_GROUND_OFFSET + heights[x][z];
            const here = world.get(x, top, z);
            if (!here) continue;
            if (
                here === BLOCK.Sand ||
                here === BLOCK.Sandstone ||
                here === BLOCK.Water ||
                here === BLOCK.Ice
            ) continue;

            // skip if anything is sitting on top (snow_block, leaves, decorations)
            const above = world.get(x, top + 1, z);
            if (above) continue;

            if (
                fluidAt(x + 1, z) ||
                fluidAt(x - 1, z) ||
                fluidAt(x, z + 1) ||
                fluidAt(x, z - 1)
            ) {
                world.set(x, top, z, BLOCK.Sand);
            }
        }
    }
}
